import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { imcSyncApiRef } from './api/ImcSyncApi';
import { ImcSyncClient } from './api/ImcSyncClient';

export const imcSyncPlugin = createPlugin({
  id: 'imc-sync',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: imcSyncApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, fetchApi, configApi }) =>
        new ImcSyncClient({ discoveryApi, fetchApi, configApi }),
    }),
  ],
});

export const ImcSyncPage = imcSyncPlugin.provide(
  createRoutableExtension({
    name: 'ImcSyncPage',
    component: () =>
      import('./components/ImcSyncPage/ImcSyncPage').then(m => m.ImcSyncPage),
    mountPoint: rootRouteRef,
  }),
);
